import React from 'react';
import {ListGroup, Form} from 'react-bootstrap';
import Match from './Match'
import classes from './search.module.css';

const Search = ( props ) => {

    

    const MatchStyles = {
        marginTop:"40%"
    }


      return (
        
        <div>
            <input 
                //style={SearchStyles}
                className={classes.search}
                placeholder="Search for a Link Near you..." 
                onChange = {props.handleInputChange} 
                value = {props.myValue}
            /> 
            <div className={classes.list}>   
            <li defaultActiveKey={props.showMatches}>
              {
                props.matches.map(match => {
                  return <Match 
                            longitude={match.longitude}
                            latitude={match.latitude} 
                            address={match.street_address} 
                            handleInputChange={props.handleInputChange}
                            alertClicked = {props.alertClicked}
                            showMatches = {props.showMatches}
                            />
                })
              }
            </li>
            </div>
        </div>
    );
};

export default Search;


/**
 * 
 * <Form style = {{width: "75%"}} onSubmit = {this.handleSubmit}>
            <Form.Group controlId="formSearch">
                <Form.Control type="text" name = "my_search" placeholder="Search for a Link Near you..." onChange = {this.handleInputChange} />
                </Form.Group>
                <Button variant="primary" type="submit">
                Search
                </Button>
            </Form>
 */